import { Label } from "@/components/ui/label";

const InputTitleDescription = ({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-row w-full items-center justify-between">
      <div className="flex flex-col gap-1">
        <Label htmlFor={title} className="flex flex-col items-start">
          <span>{title}</span>
          <p className="text-xs text-muted-foreground">{description}</p>
        </Label>
      </div>
      {children}
    </div>
  );
};

export default InputTitleDescription;
